/* ============================================================
   DAV — Modal popup logic
   - Template clone on click → render istantaneo
   - Predictive image preload on hover
   - ESC + overlay close, body lock
   ============================================================ */
(function () {
  'use strict';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }

  /* Sposta il modal sotto <body> (pattern portal).
     Necessario perché alcuni ancestor (.mp-mp con overflow:hidden + isolation,
     o sezioni con transform/will-change) creano containing block che fanno
     comportare position:fixed come position:absolute al parent — il modal
     risulta tagliato/spostato in base allo scroll. Portarlo nel body
     ripristina il comportamento corretto di "fissato al viewport". */
  function ensurePortal(modal) {
    if (!modal || modal.parentElement === document.body) return;
    if (modal.dataset.davPortaled === '1') return;
    modal.dataset.davPortaled = '1';
    document.body.appendChild(modal);
  }

  function openModal(section, card) {
    var modal = $('[data-dav-modal]', section) || $('[data-dav-modal][data-dav-section-id="' + section.dataset.davSectionId + '"]');
    if (!modal) {
      /* Se è già stato portato nel body, recuperalo via section id */
      modal = document.querySelector('[data-dav-modal][data-dav-section-id="' + section.dataset.davSectionId + '"]');
    }
    if (!modal) return;

    ensurePortal(modal);

    var slot = modal.querySelector('[data-dav-modal-content]');
    if (!slot) return;

    var id = card.getAttribute('data-id');
    if (!id) return;

    var tpl = document.getElementById('dav-tpl-' + id);
    if (!tpl || !tpl.content) return;

    slot.replaceChildren(tpl.content.cloneNode(true));

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('dav-no-scroll');

    requestAnimationFrame(function () {
      var closeBtn = modal.querySelector('.dav-modal__close');
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    });
  }

  function closeModal(section) {
    /* Cerca modal sia dentro la section che nel body (post-portal) */
    var modal = $('[data-dav-modal]', section);
    if (!modal && section.dataset.davSectionId) {
      modal = document.querySelector('[data-dav-modal][data-dav-section-id="' + section.dataset.davSectionId + '"]');
    }
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('dav-no-scroll');
  }

  function preloadModalImage(card) {
    var id = card.getAttribute('data-id');
    if (!id) return;
    var tpl = document.getElementById('dav-tpl-' + id);
    if (!tpl || !tpl.content) return;
    var img = tpl.content.querySelector('img.dav-modal__img');
    if (!img || img.dataset.preloaded) return;
    var src = img.getAttribute('src');
    if (!src) return;
    var pre = new Image();
    pre.decoding = 'async';
    pre.src = src;
    img.dataset.preloaded = '1';
  }

  function attach(section) {
    if (section.dataset.davInit) return;
    section.dataset.davInit = '1';

    /* Genera un id univoco per linkare section ↔ modal dopo il portal */
    if (!section.dataset.davSectionId) {
      section.dataset.davSectionId = 'dav-sec-' + Math.random().toString(36).slice(2, 9);
    }
    var modal = $('[data-dav-modal]', section);
    if (modal && !modal.dataset.davSectionId) {
      modal.dataset.davSectionId = section.dataset.davSectionId;
    }
    /* Subito porta il modal nel body, così il position:fixed funziona
       indipendentemente da overflow:hidden o transform sugli ancestor. */
    if (modal) ensurePortal(modal);

    var cards = $$('[data-dav-card]', section);

    cards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        if (e.target.closest('a')) return;
        openModal(section, card);
      });

      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openModal(section, card);
        }
      });

      card.addEventListener('mouseenter', function () { preloadModalImage(card); }, { passive: true });
      card.addEventListener('focus', function () { preloadModalImage(card); }, true);
    });

    /* I bottoni close possono essere sulla section (placeholder) o sul modal
       (post-portal). Attach a entrambi. */
    var closeTargets = $$('[data-dav-close]', section);
    if (modal) {
      $$('[data-dav-close]', modal).forEach(function (b) { closeTargets.push(b); });
    }
    closeTargets.forEach(function (btn) {
      btn.addEventListener('click', function () { closeModal(section); });
    });
  }

  function init() {
    /* Init su qualsiasi container che abbia un data-dav-modal child.
       Funziona sia per .dav-section (DAV) che per .mp-mp (home materie). */
    var modals = $$('[data-dav-modal]');
    var sections = [];
    modals.forEach(function (m) {
      var s = m.closest('section');
      if (s && sections.indexOf(s) === -1) sections.push(s);
    });
    sections.forEach(attach);
  }

  if (!window.__davEscBound) {
    window.__davEscBound = true;
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        $$('.dav-modal.is-open').forEach(function (m) {
          m.classList.remove('is-open');
          m.setAttribute('aria-hidden', 'true');
        });
        document.body.classList.remove('dav-no-scroll');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
